import { createFileRoute } from "@tanstack/react-router";

import { SectionThreadPage } from "@/pages/Section";

export const Route = createFileRoute("/app/companies/$company_id/sections/$section_id/threads/$thread_id")({
  component: SectionThreadPage,
});
